module.exports = "//public.getcloudapp.com/packs/media/images/annotate-567238848fb583c97d364754284bd62c.svg";